import { DataManager, AdaptorOptions } from '@syncfusion/ej2-data';

export class MyDataManager extends DataManager {

    constructor(url: string, adaptor: AdaptorOptions, token: string) {
        super({ url: url, adaptor: adaptor, crossDomain: true, headers: [{ 'Authorization': `Bearer ${token}` }] });
    }
}
